// extracted by mini-css-extract-plugin
export default {"grid":"grid__1zvbM","text":"text__1mKZ9"};